import { RiskAnalytics } from './../models/risk-analytics';

export class RiskAnalyticsBuilder {
	private riskAnalytics: RiskAnalytics;

	constructor() {
		this.riskAnalytics = new RiskAnalytics();
	}

	public setUpsideCapture(upsideCapture: string): RiskAnalyticsBuilder {
		this.riskAnalytics.upsideCapture = upsideCapture;
		return this;
	}

	public setDownsideCapture(downsideCapture: string): RiskAnalyticsBuilder {
		this.riskAnalytics.downsideCapture = downsideCapture;
		return this;
	}

	public setSharpeRatio(sharpeRatio: string): RiskAnalyticsBuilder {
		this.riskAnalytics.sharpeRatio = sharpeRatio;
		return this;
	}

	public setSharpeRatio3Yr(sharpeRatio3Yr: string): RiskAnalyticsBuilder {
		this.riskAnalytics.sharpeRatio3Yr = sharpeRatio3Yr;
		return this;
	}

	public setSharpeRatio5Yr(sharpeRatio5Yr: string): RiskAnalyticsBuilder {
		this.riskAnalytics.sharpeRatio5Yr = sharpeRatio5Yr;
		return this;
	}

	public setRiskContributionMap(json: any): RiskAnalyticsBuilder {
		const riskContributionMap: Map<string, string> = new Map<string, string>();
		if (json.modelPortfolio && json.modelPortfolio.riskContributionsBySetTypeIdContributionTypeMap) {
			const riskContributionsJsonMap = json.modelPortfolio.riskContributionsBySetTypeIdContributionTypeMap[11];
			Object.keys(riskContributionsJsonMap).forEach(key => {
				if (key !== 'total_risk') {
					riskContributionMap.set(key, riskContributionsJsonMap[key].riskPercent);
				}
			});
		}
		this.riskAnalytics.riskContributionMap = riskContributionMap;
		this.riskAnalytics.riskContributionObject = riskContributionMap;
		return this;
	}

	public setStandardDeviation1Yr(standardDeviation1Yr: string): RiskAnalyticsBuilder {
		this.riskAnalytics.standardDeviation1Yr = standardDeviation1Yr;
		return this;
	}

	public setStandardDeviation3Yr(standardDeviation3Yr: string): RiskAnalyticsBuilder {
		this.riskAnalytics.standardDeviation3Yr = standardDeviation3Yr;
		return this;
	}

	public setStandardDeviation5Yr(standardDeviation5Yr: string): RiskAnalyticsBuilder {
		this.riskAnalytics.standardDeviation5Yr = standardDeviation5Yr;
		return this;
	}

	public setRiskAsOfDateMap(portfolioJson: any): RiskAnalyticsBuilder {
		const returnMap: Map<string, Date> = new Map<string, Date>();

		if (portfolioJson) {
			portfolioJson.returns.weightedAveragePerformance = portfolioJson.returns.weightedAveragePerformance || {};
			portfolioJson.returns.latestPerf = portfolioJson.returns.latestPerf || {};
			const riskContributionsData = portfolioJson.modelPortfolio
				? portfolioJson.modelPortfolio.riskContributionsBySetTypeIdContributionTypeMap
					? portfolioJson.modelPortfolio.riskContributionsBySetTypeIdContributionTypeMap[11]
					: {}
				: {};
			const latestPerfDate = portfolioJson.returns.latestPerf.asOfDate;

			const dateMap: Map<string, any> = new Map<string, any>();
			dateMap.set(
				'riskContribution',
				riskContributionsData.total_risk ? riskContributionsData.total_risk.asOfDate : riskContributionsData.rates_risk ? riskContributionsData.rates_risk.asOfDate : null
			);
			dateMap.set('standardDeviations', latestPerfDate);
			dateMap.set('sharpeRatio3Yr', latestPerfDate);
			dateMap.set('sharpeRatio5Yr', latestPerfDate);

			dateMap.forEach((date: any, key: string) => {
				if (date) {
					const dateStr = date.toString();
					returnMap.set(key, new Date(+dateStr.slice(0, 4), +dateStr.slice(-4, -2) - 1, +dateStr.slice(-2)));
				}
			});
		}
		this.riskAnalytics.riskAsOfDateMap = returnMap;
		this.riskAnalytics.riskAsOfDateObject = returnMap;
		return this;
	}

	public build(): RiskAnalytics {
		return this.riskAnalytics;
	}
}
